<template>
    <div v-if="config">
        <setting-card
            v-bind="binds"
            :hideMoreVert="true"
            :hidePrevious="true"
            @updateProfile="updateProfile()"
        >
            <v-row no-gutters class="d-flex justify-center" style="max-width: 900px">
                <v-col cols="8" class="pb-2 text-h6 pl-3"> Note de frais | Social </v-col>
                <v-col cols="8">
                    <v-row no-gutters class="rounded-xl border-thin px-2">
                        <v-col cols="9" class="d-flex align-center">
                            {{ $t("settings.paySlip") }}
                        </v-col>
                        <v-col cols="3" class="d-flex justify-end">
                            <v-switch v-model="config.createPaySlip" />
                        </v-col>
                        <v-col cols="12">
                            <v-divider />
                        </v-col>
                        <v-col cols="9" class="d-flex align-center">
                            {{ $t("settings.expenseReport") }}
                        </v-col>
                        <v-col cols="3" class="d-flex justify-end">
                            <v-switch v-model="config.createExpenseReport" />
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="8" class="pb-2 pt-6 text-h6 pl-3"> Vente </v-col>
                <v-col cols="8">
                    <v-row no-gutters class="rounded-xl border-thin px-2">
                        <v-col cols="9" class="d-flex align-center">
                            {{ $t("settings.salesInvoice") }}
                        </v-col>
                        <v-col cols="3" class="d-flex justify-end">
                            <v-switch v-model="config.createSalesInvoice" />
                        </v-col>
                        <v-col cols="12">
                            <v-divider />
                        </v-col>
                        <v-col cols="5" class="d-flex align-center">
                            {{ $t("settings.zTillReceipt") }}
                        </v-col>
                        <v-col
                            cols="7"
                            class="d-flex justify-end align-center"
                            style="height: 62px"
                        >
                            <v-select-filled
                                v-model="zTillReceipt"
                                :items="zTillReceiptOptions"
                                :label="$t('settings.zTillReceipt')"
                                hide-details
                                outlined
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </setting-card>
    </div>
</template>

<script lang="ts">
import settingCard from "../SettingCard.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

const BobbeeImg = require("../../../assets/img/bobbee_mini.png");

@Component({
    components: {
        settingCard,
    },
    emits: ["updateProfile"],
})
export class SettingExpenseAndIncome extends Vue {
    @Prop({ default: null }) config!: any;

    get binds() {
        return {
            title: "Options charges et produits",
            partnerName: "bobbee",
            text: "Choisissez les charges et produits qui concernent votre société (Achat, note de frais, salaires, vente, z de caisse)",
            // logo: BobbeeImg
        };
    }

    set zTillReceipt(value) {
        if (value === 0) {
            this.config.createZTillReceipt = false;
            this.config.zTillReceiptWithTransactions = false;
        } else {
            this.config.createZTillReceipt = true;
            value === 2
                ? (this.config.zTillReceiptWithTransactions = true)
                : (this.config.zTillReceiptWithTransactions = false);
        }
    }

    get zTillReceipt() {
        if (!this.config.createZTillReceipt) return 0;
        if (!this.config.zTillReceiptWithTransactions) return 1;
        return 2;
    }

    get zTillReceiptOptions() {
        let options: any = [
            { title: this.$t("settings.noZTillReceipt"), value: 0 },
            { title: this.$t("settings.zTillReceiptWithTransactions") + " (Recommandé)", value: 2 },
        ];
        if (this.zTillReceipt === 1) {
            options.push({ title: this.$t("settings.zTillReceipt"), value: 1, disabled: true });
        }
        return options;
    }

    updateProfile() {
        debugger;
        this.$emit("updateProfile");
    }

    validCategory = ["ALL", "OTHER"];

    searchCondition(search: string) {
        return (
            this.binds.title.toLowerCase().includes(search.toLowerCase()) ||
            this.binds.partnerName.toLowerCase().includes(search.toLowerCase()) ||
            this.binds.text.toLowerCase().includes(search.toLowerCase())
        );
    }

    displayCondition(
        search = "",
        tab: "ALL" | "BANK" | "MAIL" | "INVOICE" | "PAYEMENT" | "OTHER" = "ALL"
    ) {
        if (search) {
            return this.validCategory.includes(tab) && this.searchCondition(search);
        }
        return this.validCategory.includes(tab);
    }
}

export default toNative(SettingExpenseAndIncome);
</script>
